module.exports = __webpack_public_path__ + "static/media/placement-test.d8939e5f.jpg";